import { useModalA11y } from '../../hooks/useModalA11y.js';

export default function SinodoDisclaimerModal({ onAccept, onCancel }) {
  const modalA11y = useModalA11y(true, onCancel, 'sinodo-title');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in">
      <div {...modalA11y} className="bg-surface-container-high border border-outline-variant/30 max-w-lg w-full rounded-2xl p-6 md:p-8 shadow-2xl flex flex-col space-y-5 animate-scale-up text-on-surface">
        <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-2 text-primary shadow-inner">
          <span className="material-symbols-outlined text-3xl">groups</span>
        </div>

        <div className="text-center space-y-2">
          <h2 id="sinodo-title" className="font-serif text-2xl font-bold tracking-tight leading-snug">
            Sobre o Sínodo Virtual
          </h2>
          <p className="text-sm font-light text-on-surface-variant leading-relaxed">
            Antes de usar este recurso pela primeira vez, é importante entender o que ele é — e o que não é.
          </p>
        </div>

        <ul className="space-y-3 text-xs leading-relaxed">
          <li className="flex items-start gap-3 p-3 rounded-xl bg-surface-container-lowest border border-outline-variant/20">
            <span className="material-symbols-outlined text-primary text-lg">smart_toy</span>
            <span>
              <strong>É uma simulação gerada por Inteligência Artificial.</strong> Não representa um sínodo
              oficial da Igreja, nem um sacerdote real, nem orientação pastoral individual.
            </span>
          </li>
          <li className="flex items-start gap-3 p-3 rounded-xl bg-surface-container-lowest border border-outline-variant/20">
            <span className="material-symbols-outlined text-primary text-lg">theater_comedy</span>
            <span>
              "Teólogo" e "Padre Amigo" são <strong>estilos de resposta de IA</strong>, não pessoas reais. A
              síntese final também é gerada por IA, não por um moderador humano.
            </span>
          </li>
          <li className="flex items-start gap-3 p-3 rounded-xl bg-surface-container-lowest border border-outline-variant/20">
            <span className="material-symbols-outlined text-primary text-lg">toll</span>
            <span>
              Cada consulta custa <strong>2 créditos</strong> (o dobro de uma mensagem normal), pois gera três
              respostas de IA em paralelo.
            </span>
          </li>
          <li className="flex items-start gap-3 p-3 rounded-xl bg-surface-container-lowest border border-outline-variant/20">
            <span className="material-symbols-outlined text-primary text-lg">menu_book</span>
            <span>
              Para acompanhamento espiritual pessoal ou dúvidas doutrinárias importantes, procure sempre um
              sacerdote ou orientador de sua confiança.
            </span>
          </li>
        </ul>

        <div className="flex flex-col gap-2">
          <button
            onClick={onAccept}
            className="w-full py-3.5 bg-primary text-on-primary font-bold rounded-xl shadow-lg hover:opacity-95 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined text-xl">done_all</span>
            <span>Entendi, quero continuar</span>
          </button>
          <button
            onClick={onCancel}
            className="text-xs text-on-surface-variant hover:text-primary transition-colors font-medium underline block mx-auto pt-1"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
